import { StreamListFilterParams } from '@anm/api/modules/stream';
import { SECOND_MS } from '@anm/constants/date';
import useIsMountedCheck from '@anm/hooks/useIsMountedCheck';
import usePageVisibility from '@anm/hooks/usePageVisibility';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { LiveTab } from '..';
import { appMetaSelectors } from '../../../../store/modules/appMeta';
import { streamActions, streamSelectors } from '../../../../store/modules/stream';

const useFetchStreams = (params?: StreamListFilterParams | null, tab?: LiveTab) => {
  const dispatch = useDispatch();
  const workspace = useSelector(appMetaSelectors.selectWorkspace);
  const isMoveStreamPending = useSelector(streamSelectors.selectMoveStreamPending);

  const isPageVisible = usePageVisibility();

  useEffect(() => {
    if (tab !== 'in-progress') return;

    const interval = setInterval(() => {
      dispatch(streamActions.reFetchStreamsList());
    }, SECOND_MS * 10);

    return () => {
      clearInterval(interval);
    };
  }, [tab]);

  const isMounted = useIsMountedCheck();

  useEffect(() => {
    isMounted && isPageVisible && dispatch(streamActions.reFetchStreamsList());
  }, [isPageVisible]);

  useEffect(() => {
    if (params === null || isMoveStreamPending) return;

    dispatch(streamActions.fetchStreamsList(params));
  }, [params?.state, params?.sort, params?.projectId, params?.sortOrder, workspace, isMoveStreamPending]);
};

export default useFetchStreams;
